export default class Validator {
    constructor() {
        this.decimalSeparator = '.';
    }

    zipcode(value) {
        return !!(value.match(/^((0[1-57-9])|([1-6][0-9])|(7[0-35-9])|(8[0-2]))[0-9]{4}$/));
    }
}
